"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFab = void 0;
var colors_1 = require("../colors");
exports.MuiFab = {
    defaultProps: {
        variant: 'extended',
        disableFocusRipple: true,
        disableRipple: true,
        disableTouchRipple: true,
    },
    variants: [
        {
            props: { color: 'blue' },
            style: {
                color: colors_1.tannerBlue['500'],
                '&.Mui-disabled': {
                    boxShadow: 'none',
                    color: "".concat(colors_1.tannerBlue['500'], "99"),
                    'span .MuiBox-root': {
                        color: colors_1.tannerBlue['500'],
                    },
                },
            },
        },
        {
            props: { color: 'secondary' },
            style: {
                color: colors_1.tannerBlack,
                '&.Mui-disabled': {
                    boxShadow: 'none',
                    color: "".concat(colors_1.tannerBlack, "99"),
                    'span .MuiBox-root': {
                        color: colors_1.tannerBlack,
                    },
                },
            },
        },
        {
            props: { color: 'error' },
            style: {
                color: colors_1.tannerSemantic.error.color,
                '&.Mui-disabled': {
                    boxShadow: 'none',
                    color: "".concat(colors_1.tannerSemantic.error.color, "99"),
                    'span .MuiBox-root': {
                        color: colors_1.tannerSemantic.error.color,
                    },
                },
            },
        },
        {
            props: { variant: 'circular' },
            style: {
                borderRadius: '50%',
                height: 40,
                width: 40,
                padding: 0,
            },
        },
    ],
    styleOverrides: {
        root: {
            borderRadius: 100,
            background: colors_1.tannerGray['50'],
            boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.17), 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
            height: '40px',
            lineHeight: '140%',
            color: colors_1.tannerPurple['500'],
            fontSize: 14,
            padding: '8px 16px 8px 16px',
            fontWeight: 700,
            textTransform: 'none',
            '&:hover': {
                background: colors_1.tannerGray['200'],
                boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 4px 5px 0px rgba(0, 0, 0, 0.12), 0px 1px 10px 0px rgba(0, 0, 0, 0.20)',
            },
            '&:active': {
                background: colors_1.tannerGray['300'],
                boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.17), 0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
            },
            '&.Mui-disabled': {
                boxShadow: 'none',
                background: colors_1.tannerGray['100'],
                color: "".concat(colors_1.tannerPurple['500'], "99"),
                'span .MuiBox-root': {
                    color: colors_1.tannerPurple['500'],
                },
            },
            '&:focus-visible': {
                borderRadius: '37px',
                outline: "3px solid ".concat(colors_1.tannerSemantic.info.color),
                outlineOffset: 3,
                transition: 'outline-offset 150ms',
            },
        },
    },
};
//# sourceMappingURL=MuiFab.js.map